"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperText = exports.MainText = exports.Wrapper = exports.Container = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const mediaQuery_enum_1 = require("../../core/mediaQuery.enum");
const theme_1 = require("../../providers/themeProvider/theme");
exports.Container = (0, styled_components_1.default)(material_1.Box) `
  display: flex;
  justify-content: center;
  margin-top: 60px;

  @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
    margin-top: 100px;
  }
`;
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background-color: #eff0f5;
  border-radius: ${theme_1.theme.shape.borderRadius * 2}px;
  max-width: 375px;
  padding: 30px 10px;

  @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
    padding: 30px 12px;
  }
`;
exports.MainText = (0, styled_components_1.default)(material_1.Typography) `
  padding: 8px 20px;
  font-weight: 700;
  line-height: 22px;
`;
exports.HelperText = (0, styled_components_1.default)(material_1.Typography) `
  line-height: 22px;
`;
